module.exports = __webpack_public_path__ + "static/media/left-round-active.9077bdb2.svg";